module.exports = __webpack_public_path__ + "media/images/metronic/social/vk-bf90797d787d7037204403ffe4edaa0a.png";